import types from "./types";

export function allClientes() {
  return { type: types.ALL_CLIENTES };
}
export function updateCliente(payload) {
    return { type: types.UPDATE_CLIENTE , payload};
  }
export function updateDataCliente() {
    return { type: types.UPDATE_DATA_CLIENTE };
  }
  
export function updateCNHCliente() {
    return { type: types.UPDATE_CNH_CLIENTE };
  }
  
  export function filterClientes() {
    return { type: types.FILTER_CLIENTES };
  }
  export function filterClientesCnh() {
    return { type: types.FILTER_CLIENTES_CNH };
  }
  export function addClientes() {
    return { type: types.ADD_CLIENTES };
  }
  export function stepCodeInsert() {
    return { type: types.ADD_STEP_CODE_INSERT };
  }
  export function addClientesStepTwo() {
    return { type: types.ADD_CLIENTES_TWO };
  }
  export function resetClientes() {
    return { type: types.RESET_CLIENTES };
  }
  export function resetStep1() {
    return { type: types.RESET_STEP1 };
  }
  export function resetStep2() {
    return { type: types.RESET_STEP2 };
  }
  export function unlinkClientes() { //Soft Remove
    return { type: types.UNLINK_CLIENTES };
  }
  export function loginSession(payload) { //Soft Remove
    return { type: types.LOGIN_SESSION_IN , payload};
  }
  export function sessionLogOut() { //Soft Remove
    return { type: types.LOGIN_SESSION_OUT  };
  }
  